import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { useRef } from "react";
import { useState, useMemo } from "react";
import { ScrollView as RNScrollView } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { ProposalsResource } from "@repo/core/services/resources/proposals";
import { apiInstance } from "@repo/core/services/instances/api";
import { mapRecentProposals } from "@repo/core/mappers/proposals";
import { ProposalCardProps } from "@repo/core/components/layout/ProposalCard/types";

const proposalsResource = new ProposalsResource(apiInstance);

export const useRecentProposalsController = () => {
  const { width } = useDimensions();
  const { push } = useNavigation();

  const refScroll = useRef<RNScrollView | undefined>(undefined);
  const [currentPosition, setCurrentPosition] = useState(0);
  const isResponsive = width <= 1024;

  const showCarrousel = !isResponsive;

  const { data: proposalsData, isFetching } = useQuery({
    queryKey: ["recentProposals"],
    queryFn: () => proposalsResource.consultProposals()
  });

  const recentProposals: ProposalCardProps[] = useMemo(() => {
    if (!proposalsData?.data) {
      return [];
    }

    return mapRecentProposals(proposalsData.data, 5);
  }, [proposalsData]);

  const handleGoToAllProposals = () => {
    push(ROUTES.proposals);
  };

  const goLeft = () => {
    if (refScroll.current) {
      const newPosition = currentPosition - 400;
      refScroll?.current?.scrollTo({
        x: newPosition,
        animated: true
      });
    }
  };

  const goRight = () => {
    if (refScroll.current) {
      const newPosition = currentPosition + 400;
      refScroll?.current?.scrollTo({
        x: newPosition,
        animated: true
      });
    }
  };

  return {
    recentProposals,
    isResponsive,
    goLeft,
    goRight,
    setCurrentPosition,
    refScroll,
    showCarrousel,
    handleGoToAllProposals,
    isFetching
  };
};
